import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Label from "@/components/Label";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="mx-auto flex max-w-[1400px] flex-col items-center justify-center px-5 py-32 text-center md:py-48"
    >
      <Seo title="Page Not Found" noindex />
      <Label className="mb-4">Page Not Found</Label>
      <h1 className="font-serif-display text-6xl md:text-8xl font-normal tracking-tight">
        404
      </h1>
      <p className="mt-4 max-w-sm text-base text-[#3d3d3d]">
        This page seems to have stepped out for a facial. Let&apos;s get you back.
      </p>
      <Link
        to="/"
        className="group mt-10 inline-flex items-center gap-2 bg-[#050505] px-10 py-4 text-sm uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-white hover:text-[#050505] border border-[#050505]"
      >
        <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
        Back home
      </Link>
    </div>
  );
}
